import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../../blocks/message/MessageContext";
import { Spinner } from "@fluentui/react-components";
import { relationFormFields } from "./RelationFormFields";
import { ENTITY_RELATION } from "../../../utils/Constants";
import Ows from "../../../utils/OwsHandler";
import Form from "../../form/Form";

const RelationForm = () => {
  const navigate = useNavigate();
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);
  const [statusList, setStatusList] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const data = await Ows.handleRequest("Otys.Services.RelationService.getOptionLists", [["statusId"]]);

        if (data.error) {
          throw new Error(data.error.message);
        }

        setStatusList(data.response.statusId || {});
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  const createRelation = async (formData) => {
    setLoading(true);
    try {
      const data = await Ows.handleRequest("Otys.Services.RelationService.add", [
        {
          relation: formData.companyName,
          email: formData.email,
          phoneNumberMain: formData.phone,
          statusId: formData.status,
          website: formData.website,
        },
      ]);

      if (data.error) {
        throw new Error(data.error.message);
      }

      return data.response;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    const uid = await createRelation(formData);

    if (!uid) {
      showMessage("error", "Failed to create relation.");
    } else {
      showMessage("success", "Relation created successfully.");
      navigate(`/${ENTITY_RELATION.toLowerCase()}/${uid}`, { state: { skipPageHeader: true } });
    }
  };

  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <Form title="Create new relation" fields={relationFormFields(statusList)} onSubmit={handleSubmit} />
      )}
    </div>
  );
};

export default RelationForm;
